import { makeStyles } from '@material-ui/core';
import apnaLogo from './apna-logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 36,
    display: 'block',
    borderRadius: 8,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      alt="Apna"
      className={classes.img}
      src={apnaLogo}
    />
  );
};
